
import { message } from 'antd';
import { find } from 'lodash';
import { addAndUpdateVendorCtsfm, getVendorCtsfm, deleteVendorCtsfm } from '../services/supplierApi';


function init() {
  return {
    data: [],
    record: {},
    visiable: false
  };
}

export default {
  namespace: 'processAbility',
  state: init(),
  effects: {
    *getData(_, { call, put }) {
      const res = yield call(getVendorCtsfm);
      if (res.success) {
        yield put({
          type: 'updateState',
          payload: {
            data: {
              data: res.data
            }
          }
        });
      } else {
        res.msg && message.error(res.msg);
      }
    },
    *showEditModal({ payload: { data: { serialNumberC } } }, { put, select }) {
      const data = yield select(state => state.processAbility.data);
      const record = find(data, { serialNumberC });
      yield put({
        type: 'updateState',
        payload: {
          data: {
            record,
            visible: true
          }
        }
      });
    },
    *addAndUpdate({ payload: { data } }, { call, put }) {
      const result = yield call(addAndUpdateVendorCtsfm, data);
      if (result.success) {
        message.success('操作成功');
        yield put({
          type: 'updateState',
          payload: {
            data: {
              visible: false
            }
          }
        });
        yield put({
          type: 'getData'
        });
      } else {
        result.msg && message.error(result.msg);
      }
    },
    *delete({ payload: { serialNumberC } }, { call, put }) {
      const result = yield call(deleteVendorCtsfm, { serialNumber: serialNumberC });
      if (result.success) {
        message.success('操作成功');
        yield put({
          type: 'getData'
        });
      } else {
        result.msg && message.error(result.msg);
      }
    },
  },
  reducers: {
    updateState(state, { payload: { data } }) {
      return {
        ...state,
        ...data
      };
    },
    clear() {
      return init();
    }
  }
};

